import { render, staticRenderFns } from "./dateType.vue?vue&type=template&id=08a83bfa&scoped=true"
import script from "./dateType.vue?vue&type=script&lang=js"
export * from "./dateType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a83bfa",
  null
  
)

export default component.exports